module.exports = __webpack_public_path__ + "static/media/resume_blue.55c031ea.pdf";